// Normalise the line/page wheel delta modes to pixels.
export const getWheelDeltaPx = (delta: number, event: WheelEvent, scroller: HTMLElement) => (
    delta * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? scroller.clientWidth : 1)
)

// Scroll horizontally while there's hidden content; at an edge and scrolling
// further out — leave the event to the page.
export const scrollHorizontallyByWheel = (scroller: HTMLElement, delta: number, event: WheelEvent) => {
    const maxScroll = scroller.scrollWidth - scroller.clientWidth
    if (maxScroll <= 0) return

    const atStart = scroller.scrollLeft <= 0
    const atEnd = scroller.scrollLeft >= maxScroll - 1
    if ((atStart && delta < 0) || (atEnd && delta > 0)) return

    event.preventDefault()
    scroller.scrollLeft += delta
}
